"use client";

import { memo } from "react";
import { HeroDark } from "@/components/screen/global-components/hero";
import { ROUTES } from "@/constants";

const SecurityHero = ({}: React.ComponentProps<"section">) => {
  return (
    <HeroDark
      title="Languex Trust Center"
      description="We prioritize and are committed to our clients, their data, and content security."
      primaryButton={{
        href: ROUTES.startOrder,
        label: 'Start order'
      }}
    />
  );
};

export default memo(SecurityHero);
